module.exports = __webpack_public_path__ + "img/vu.86c57bf2.svg";